/**
 * INTERRUPTOR DEL SEGUIMIENTO POR CHAT (bloque 8, interruptor mínimo; C6 de docs/SEGUIMIENTO.md).
 *
 * El backend ya lo respeta: el clasificador no abre fichas (`debeClasificar`) y el barrido no
 * manda toques (`decisionPreEnvio`, motivo `operador-apago`) con `seguimientoAuto.operador ===
 * 'off'`. Esto es sólo lo que escribe la UI, y tiene dos reglas que no se negocian:
 *
 *   1. SÓLO APAGA (C6). Reactivar BORRA el campo; nunca escribe `'on'`. Un `'on'` sería un tercer
 *      estado que ningún lector conoce, y el día que el bot se apague no debe quedar un chat
 *      «forzado a encendido».
 *   2. NO REORDENA LA BANDEJA (C8): ni `actualizadoEn` ni `lastTs`. Se escribe anidado con
 *      `merge`, que conserva `activo`, `ultimaRespuestaBoton` y `ultimaSinRespuesta`.
 *
 * Se muestra sólo en chats donde el seguimiento ya actuó (`seguimientoAuto` existe): en los demás
 * no hay nada que apagar.
 */

/** ¿El operador apagó el seguimiento en este chat? */
export function seguimientoApagado(chat) {
  return chat?.seguimientoAuto?.operador === 'off';
}

/** ¿Se pinta el interruptor? */
export function mostrarInterruptor(chat) {
  return !!chat && !!chat.seguimientoAuto && typeof chat.seguimientoAuto === 'object';
}

/**
 * Lo que se escribe con `setDoc(ref, …, { merge: true })`. `borrar` es el centinela de Firestore
 * (`deleteField()`), inyectado para poder probarlo sin el SDK.
 */
export function escrituraDelInterruptor(chat, borrar) {
  return { seguimientoAuto: { operador: seguimientoApagado(chat) ? borrar : 'off' } };
}
